// layoutHooks.js
import { useSelector } from 'react-redux';

const useLayoutHeights = () => {
  const appState = useSelector((state) => state.globalData.appState);
  const showCompanyName = appState.settings?.show_current_company
    && appState.current_company
    && appState.current_company.name;
  const showRenalMangagment = appState.settings?.show_rental_management_link;
  const showUtilityNav = showCompanyName || showRenalMangagment;

  return {
    LAYOUT_HEIGHT: showUtilityNav ? 13.125 : 8.75,
    LAYOUT_HEIGHT_SM: showUtilityNav ? 12.725 : 8.375,
  };
};
export default useLayoutHeights;
